import {
    Icon,
    ToggleButton,
    ToggleButtonGroup,
    useMediaQuery,
    useTheme,
} from "@mui/material";

export default function ViewPreference(props: {
    preferDesktop: boolean;
    onChange: (preferDesktop: boolean) => void;
}) {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    if (isSmallScreen) {
        return <></>;
    }

    const onPreferenceChange = (
        event: React.MouseEvent<HTMLElement>,
        preferDesktop: boolean | null
    ) => {
        if (preferDesktop === null) {
            return;
        }
        props.onChange(preferDesktop);
    };

    return (
        <ToggleButtonGroup
            value={props.preferDesktop}
            exclusive
            sx={{ height: 33 }}
            size="small"
            color="primary"
            onChange={onPreferenceChange}
        >
            <ToggleButton size="small" value={true}>
                <Icon>reorder</Icon>
            </ToggleButton>
            <ToggleButton size="small" value={false}>
                <Icon>dashboard</Icon>
            </ToggleButton>
        </ToggleButtonGroup>
    );
}
